(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8787],{

/***/ 63652:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_ListConfirmationModal; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 16 modules
var esm = __webpack_require__(24400);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./store/features/favoritesSlice.js + 1 modules
var favoritesSlice = __webpack_require__(7737);
;// CONCATENATED MODULE: ./components/ListConfirmationModal/localization.js
const getTranslations = (t)=>{
    return {
        listActionSuccess: t("kf.saveToList.action.success.title"),
        listActionDeleteMsg: t("Kf.myList.page.delete.confirm.msg"),
        listActionDeleteSuccessBtn: t("kf.account.label.myLists"),
        noListTitle: t("Kf.myList.page.nolist"),
        noListMsg: t("Kf.myList.page.nolist.msg"),
        bestSellersBtn: t("Kf.myList.page.shop.bestsellers"),
        deleteListTitle: t("kf.myList.page.deletList"),
        deleteDec: t("Kf.myList.page.delete.dec"),
        deleteListBtn: t("kf.myList.page.deletList"),
        deleteFromList: t("kf.myList.page.deletFromList"),
        deleteFromListDec: t("kf.myList.page.deletFromList.msg"),
        deleteFromListConfirmMsg: t("kf.myList.page.deletFromList.confirm.msg"),
        deleteProductFromList: t("kf.button.action.delete"),
        closeBtnTextForList: t("kf.checkout.label.close"),
        deleteProductFormListCloseMsg: t("kf.myList.page.deleteProduct.dec"),
        multiDeleteHeader: t("kf.delete.items.from.list.header"),
        multiDeleteFromListDec: t("kf.delete.items.from.list.dec"),
        multiDeleteBtnTex: t("kf.delete.items.from.list.btn"),
        multiDeleteSuccessDec: t("kf.delete.items.from.list.success.dec"),
        multiDeleteSuccessBtnTex: t("kf.myList.page.delete.success.btn")
    };
};

// EXTERNAL MODULE: ./components/Shared/Image/index.js
var Image = __webpack_require__(70914);
// EXTERNAL MODULE: ./public/icons/modal-close.svg
var modal_close = __webpack_require__(55619);
// EXTERNAL MODULE: ./components/ListConfirmationModal/index.module.scss
var index_module = __webpack_require__(47486);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./store/features/genericSlice.js
var genericSlice = __webpack_require__(88751);
// EXTERNAL MODULE: ./constants/routes.js
var routes = __webpack_require__(64757);
;// CONCATENATED MODULE: ./components/ListConfirmationModal/index.jsx












const ListConfirmationModal = (props)=>{
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const staticText = getTranslations(t);
    const dispatch = (0,es/* useDispatch */.I0)();
    const router = (0,next_router.useRouter)();
    const { list ={} , openConforMationModal =false , noLineItems =false , deleteList =false , deletefromListDetails =false , deleteFromList =false , closeConformationModal =()=>{} , deleteConfirmationModal =()=>{} , setSelectedList =()=>{} , handleSuccessCallBack =()=>{} , closeModalWithOutDelete =()=>{} , selectedItems =[] , multiDeleteFromList =false  } = props || {};
    const { globalConfig: { internationalization: { locale: newLocale = "en-US" , language ="en"  } = {}  } = {}  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const [headerTxt, setHeaderTxt] = (0,react.useState)("");
    const [decTxt, setDecTxt] = (0,react.useState)("");
    const [btnTxt, setBtnTxt] = (0,react.useState)("");
    const [deleteSuccess, setDeleteSuccess] = (0,react.useState)(false);
    const [deleteSuccessResponse, setDeleteSuccessResponse] = (0,react.useState)({});
    const [actionBtnDisabled, setActionBtnDisabled] = (0,react.useState)(false);
    const handleClose = ()=>{
        if (deleteSuccess) {
            if (multiDeleteFromList) {
                handleSuccessCallBack(deleteSuccessResponse);
            } else {
                dispatch((0,favoritesSlice/* getMyAccountListsWithLineItems */.WQ)());
                handleSuccessCallBack();
            }
        }
        if (btnTxt !== "My Lists" && deletefromListDetails) {
            closeModalWithOutDelete();
        } else if (multiDeleteFromList && !deleteSuccess) {
            closeModalWithOutDelete();
        } else {
            closeConformationModal();
        }
        deleteConfirmationModal();
    };
    const handleActionbtn = ()=>{
        if (btnTxt === "My Lists") {
            if (deleteList) {
                router.push("/".concat(language).concat(routes/* MY_LISTS_PAGE_PATH */.PN));
            } else if (deleteFromList) {
                setSelectedList(deleteSuccessResponse === null || deleteSuccessResponse === void 0 ? void 0 : deleteSuccessResponse.id);
                deleteConfirmationModal();
                router.push("/".concat(language).concat(routes/* MY_LISTS_PAGE_PATH */.PN, "?listId=").concat(deleteSuccessResponse === null || deleteSuccessResponse === void 0 ? void 0 : deleteSuccessResponse.id));
            }
        } else if (btnTxt === "Close" && deleteFromList) {
            deleteConfirmationModal();
            closeConformationModal();
        }
        if (multiDeleteFromList && deleteSuccess) {
            handleSuccessCallBack(deleteSuccessResponse);
        } else if (deleteSuccess) {
            if (!deletefromListDetails) {
                dispatch((0,favoritesSlice/* getMyAccountListsWithLineItems */.WQ)());
            }
            handleSuccessCallBack();
            closeConformationModal();
        } else if (noLineItems) {
            router.push("/".concat(language).concat(routes/* PRODUCT_BEST_SELLERS */.RG));
        } else if (deleteList || deletefromListDetails) {
            setActionBtnDisabled(true);
            dispatch((0,favoritesSlice/* deleteUserList */.iF)(list)).unwrap().then((resonse)=>{
                setDeleteSuccess(true);
                setActionBtnDisabled(false);
                setHeaderTxt(staticText === null || staticText === void 0 ? void 0 : staticText.listActionSuccess);
                setDecTxt(staticText === null || staticText === void 0 ? void 0 : staticText.listActionDeleteMsg);
                setBtnTxt(staticText === null || staticText === void 0 ? void 0 : staticText.listActionDeleteSuccessBtn);
            }).catch((error)=>{
                console.log(error);
            });
        } else if (deleteFromList) {
            setActionBtnDisabled(true);
            dispatch((0,favoritesSlice/* deleteProductFromList */.D3)(list)).unwrap().then((resonse)=>{
                setDeleteSuccessResponse(resonse === null || resonse === void 0 ? void 0 : resonse.data);
                setDeleteSuccess(true);
                setActionBtnDisabled(false);
                setHeaderTxt(staticText === null || staticText === void 0 ? void 0 : staticText.listActionSuccess);
                setDecTxt(staticText === null || staticText === void 0 ? void 0 : staticText.deleteFromListConfirmMsg);
                setBtnTxt(staticText === null || staticText === void 0 ? void 0 : staticText.closeBtnTextForList);
                dispatch((0,favoritesSlice/* getMyAccountListsWithLineItems */.WQ)());
            }).catch((error)=>{
                console.log(error);
            });
        } else if (multiDeleteFromList) {
            setActionBtnDisabled(true);
            dispatch((0,favoritesSlice/* deleteMultiProductFromList */.Lu)({
                list,
                selectedItems
            })).unwrap().then((resonse)=>{
                setDeleteSuccessResponse(resonse === null || resonse === void 0 ? void 0 : resonse.data);
                setDeleteSuccess(true);
                setActionBtnDisabled(false);
                setHeaderTxt(staticText === null || staticText === void 0 ? void 0 : staticText.listActionSuccess);
                setDecTxt(staticText === null || staticText === void 0 ? void 0 : staticText.multiDeleteSuccessDec);
                setBtnTxt(staticText === null || staticText === void 0 ? void 0 : staticText.closeBtnTextForList);
            }).catch((error)=>{
                console.log(error);
            });
        }
    };
    (0,react.useEffect)(()=>{
        if (noLineItems) {
            setHeaderTxt(staticText === null || staticText === void 0 ? void 0 : staticText.noListTitle);
            setDecTxt(staticText === null || staticText === void 0 ? void 0 : staticText.noListMsg);
            setBtnTxt(staticText === null || staticText === void 0 ? void 0 : staticText.bestSellersBtn);
        } else if (deleteList || deletefromListDetails) {
            setHeaderTxt(staticText === null || staticText === void 0 ? void 0 : staticText.deleteListTitle);
            setDecTxt(staticText === null || staticText === void 0 ? void 0 : staticText.deleteDec);
            setBtnTxt(staticText === null || staticText === void 0 ? void 0 : staticText.deleteListBtn);
        } else if (deleteFromList) {
            const locale = newLocale === "fr-CA" ? "en-CA" : newLocale;
            const ListName = list === null || list === void 0 ? void 0 : list.listName[locale];
            setHeaderTxt(staticText === null || staticText === void 0 ? void 0 : staticText.deleteFromList);
            setDecTxt("".concat(staticText === null || staticText === void 0 ? void 0 : staticText.deleteProductFormListCloseMsg, " '").concat(ListName, "'."));
            setBtnTxt(staticText === null || staticText === void 0 ? void 0 : staticText.deleteProductFromList);
        } else if (multiDeleteFromList) {
            setHeaderTxt(staticText === null || staticText === void 0 ? void 0 : staticText.multiDeleteHeader);
            setDecTxt(staticText === null || staticText === void 0 ? void 0 : staticText.multiDeleteFromListDec);
            setBtnTxt(staticText === null || staticText === void 0 ? void 0 : staticText.multiDeleteBtnTex);
        }
    }, [
        noLineItems,
        deleteList,
        deleteFromList,
        deletefromListDetails,
        multiDeleteFromList
    ]);
    (0,react.useEffect)(()=>{
        document.body.style.overflow = openConforMationModal ? "hidden" : "auto";
        return ()=>{
            document.body.style.overflow = "auto";
        };
    }, [
        openConforMationModal
    ]);
    return openConforMationModal ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (index_module_default()).ListConfirmationModalWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "list-confirmation-modal ".concat(deleteFromList ? "deleteFromList" : "", " "),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "close-btn",
                    onClick: handleClose,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                        src: modal_close/* default */.Z === null || modal_close/* default */.Z === void 0 ? void 0 : modal_close/* default.src */.Z.src,
                        role: "presentation",
                        alt: "close",
                        width: "17",
                        height: "30"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "list-ocnfirmation-content",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "header",
                            children: headerTxt
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "discription",
                            children: decTxt
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: "cta-button",
                            onClick: handleActionbtn,
                            disabled: actionBtnDisabled,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "cta-btn-txt",
                                children: btnTxt
                            })
                        })
                    ]
                })
            ]
        })
    }) : null;
};
/* harmony default export */ var components_ListConfirmationModal = (ListConfirmationModal);


/***/ }),

/***/ 65258:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$b": function() { return /* binding */ closeSaveToListAnalytics; },
/* harmony export */   "NG": function() { return /* binding */ closeCreateNewListSuccessAnalytics; },
/* harmony export */   "OR": function() { return /* binding */ dataLayerSavetolistGuest; },
/* harmony export */   "Y$": function() { return /* binding */ dataLayerMyListSaveListButton; },
/* harmony export */   "Yt": function() { return /* binding */ dataLayerCreateNewSaveListButton; },
/* harmony export */   "iB": function() { return /* binding */ closeCreateNewListAnalytics; },
/* harmony export */   "jX": function() { return /* binding */ closeSelectMyListAnalytics; },
/* harmony export */   "p5": function() { return /* binding */ dataLayerCreateNewListButton; },
/* harmony export */   "y3": function() { return /* binding */ dataLayerHeartClickSaveListButton; }
/* harmony export */ });
/* harmony import */ var _components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4943);

const pushToAdobeDataLayer = (eventInfo, productInfo)=>{
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = (getState === null || getState === void 0 ? void 0 : getState("page")) || {};
    window.adobeDataLayer.push({
        event: "cmp:click",
        eventInfo,
        ...productInfo ? {
            productInfo
        } : {},
        page
    });
};
const getPageType = ()=>{
    var ref;
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    var ref1;
    const pageType = (ref1 = page === null || page === void 0 ? void 0 : (ref = page.category) === null || ref === void 0 ? void 0 : ref.pageType) !== null && ref1 !== void 0 ? ref1 : "pdp";
    return pageType;
};
const dataLayerSavetolistGuest = (productInfo)=>{
    const pageType = getPageType();
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(pageType, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .PRODUCT_DETAILS */ .OH, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .SAVE_TO_LIST_GUEST */ .V7 === null || _components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .SAVE_TO_LIST_GUEST */ .V7 === void 0 ? void 0 : _components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .SAVE_TO_LIST_GUEST.toLowerCase */ .V7.toLowerCase()),
        eventMsg: "n/a",
        eventName: "".concat(pageType, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .PRODUCT_DETAILS */ .OH, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .SAVE_TO_LIST_GUEST */ .V7 === null || _components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .SAVE_TO_LIST_GUEST */ .V7 === void 0 ? void 0 : _components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .SAVE_TO_LIST_GUEST.toLowerCase */ .V7.toLowerCase()),
        eventStatus: "n/a",
        eventType: "".concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .WISHLIST_SAVE */ .O1),
        internalLinkName: "".concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .SAVE_TO_LIST */ .IP),
        internalLinkPosition: "".concat(pageType),
        internalLinkType: "".concat(pageType, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .SAVE_TO_LIST */ .IP === null || _components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .SAVE_TO_LIST */ .IP === void 0 ? void 0 : _components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .SAVE_TO_LIST.toLowerCase */ .IP.toLowerCase()),
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(pageType, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .PRODUCT_DETAILS */ .OH, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .SAVE_TO_LIST */ .IP === null || _components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .SAVE_TO_LIST */ .IP === void 0 ? void 0 : _components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .SAVE_TO_LIST.toLowerCase */ .IP.toLowerCase())
    };
    pushToAdobeDataLayer(eventInfo, productInfo);
};
const dataLayerHeartClickSaveListButton = (productInfo, headerTitle, eventType)=>{
    const pageType = getPageType();
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(pageType, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .PRODUCT_DETAILS */ .OH, ":").concat(headerTitle === null || headerTitle === void 0 ? void 0 : headerTitle.toLowerCase()),
        eventMsg: "n/a",
        eventName: "".concat(pageType, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .PRODUCT_DETAILS */ .OH, ":").concat(headerTitle === null || headerTitle === void 0 ? void 0 : headerTitle.toLowerCase()),
        eventStatus: "n/a",
        eventType: eventType,
        internalLinkName: "".concat(headerTitle === null || headerTitle === void 0 ? void 0 : headerTitle.toLowerCase()),
        internalLinkPosition: "".concat(pageType),
        internalLinkType: "".concat(pageType, ":").concat(headerTitle === null || headerTitle === void 0 ? void 0 : headerTitle.toLowerCase()),
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(pageType, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .PRODUCT_DETAILS */ .OH, ":").concat(headerTitle === null || headerTitle === void 0 ? void 0 : headerTitle.toLowerCase())
    };
    pushToAdobeDataLayer(eventInfo, productInfo);
};
const dataLayerCreateNewListButton = (productInfo, createNewListTitle)=>{
    const pageType = getPageType();
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(pageType, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .PRODUCT_DETAILS */ .OH, ":").concat(createNewListTitle === null || createNewListTitle === void 0 ? void 0 : createNewListTitle.toLowerCase()),
        eventMsg: "n/a",
        eventName: "".concat(pageType, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .PRODUCT_DETAILS */ .OH, ":").concat(createNewListTitle === null || createNewListTitle === void 0 ? void 0 : createNewListTitle.toLowerCase()),
        eventStatus: "n/a",
        eventType: "".concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .WISHLIST_SAVE */ .O1),
        internalLinkName: "".concat(createNewListTitle === null || createNewListTitle === void 0 ? void 0 : createNewListTitle.toLowerCase()),
        internalLinkPosition: "".concat(pageType),
        internalLinkType: "".concat(pageType, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .SAVE_TO_LIST */ .IP),
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(pageType, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .PRODUCT_DETAILS */ .OH, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .SAVE_TO_LIST */ .IP)
    };
    pushToAdobeDataLayer(eventInfo, productInfo);
};
const dataLayerMyListSaveListButton = function(productInfo) {
    let selectedData = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", successDesc = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", successTitle = arguments.length > 3 ? arguments[3] : void 0;
    const pageType = getPageType();
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(pageType, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .PRODUCT_DETAILS */ .OH, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .SELECT_MY_LIST */ .oF, ":").concat(successTitle === null || successTitle === void 0 ? void 0 : successTitle.toLowerCase()),
        eventMsg: "".concat(successDesc),
        eventName: "".concat(pageType, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .PRODUCT_DETAILS */ .OH, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .SELECT_MY_LIST */ .oF, ":").concat(successTitle === null || successTitle === void 0 ? void 0 : successTitle.toLowerCase()),
        eventStatus: "".concat(successTitle === null || successTitle === void 0 ? void 0 : successTitle.toLowerCase()),
        eventType: "".concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .WISHLIST_SAVE */ .O1),
        internalLinkName: "".concat(selectedData),
        internalLinkPosition: "".concat(pageType),
        internalLinkType: "".concat(pageType, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .SAVE_TO_LIST */ .IP, ":").concat(selectedData),
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(pageType, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .PRODUCT_DETAILS */ .OH, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .SAVE_TO_LIST */ .IP)
    };
    pushToAdobeDataLayer(eventInfo, productInfo);
};
const dataLayerCreateNewSaveListButton = function(productInfo) {
    let createListData = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", successDesc = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", createNewListTitle = arguments.length > 3 ? arguments[3] : void 0, successTitle = arguments.length > 4 ? arguments[4] : void 0;
    const pageType = getPageType();
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(pageType, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .PRODUCT_DETAILS */ .OH, ":").concat(createNewListTitle === null || createNewListTitle === void 0 ? void 0 : createNewListTitle.toLowerCase(), ":").concat(successTitle === null || successTitle === void 0 ? void 0 : successTitle.toLowerCase()),
        eventMsg: "".concat(successDesc),
        eventName: "".concat(pageType, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .PRODUCT_DETAILS */ .OH, ":").concat(createNewListTitle === null || createNewListTitle === void 0 ? void 0 : createNewListTitle.toLowerCase(), ":").concat(successTitle === null || successTitle === void 0 ? void 0 : successTitle.toLowerCase()),
        eventStatus: "".concat(successTitle === null || successTitle === void 0 ? void 0 : successTitle.toLowerCase()),
        eventType: "".concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .WISHLIST_SAVE */ .O1),
        internalLinkName: "".concat(createListData),
        internalLinkPosition: "".concat(pageType),
        internalLinkType: "".concat(pageType, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .SAVE_TO_LIST */ .IP, ":").concat(createListData),
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(pageType, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .PRODUCT_DETAILS */ .OH, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .SAVE_TO_LIST */ .IP)
    };
    pushToAdobeDataLayer(eventInfo, productInfo);
};
const closeSaveToListAnalytics = (productInfo)=>{
    const pageType = getPageType();
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(pageType, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .PRODUCT_DETAILS */ .OH, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .SAVE_TO_LIST */ .IP, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .CLOSE */ .F$),
        eventMsg: "n/a",
        eventName: "".concat(pageType, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .PRODUCT_DETAILS */ .OH, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .SAVE_TO_LIST */ .IP, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .CLOSE */ .F$),
        eventStatus: "n/a",
        eventType: "".concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .WISHLIST_SAVE */ .O1),
        internalLinkName: "".concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .CLOSE */ .F$),
        internalLinkPosition: "".concat(pageType),
        internalLinkType: "".concat(pageType, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .SAVE_TO_LIST */ .IP),
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(pageType, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .PRODUCT_DETAILS */ .OH, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .SAVE_TO_LIST */ .IP)
    };
    pushToAdobeDataLayer(eventInfo, productInfo);
};
const closeCreateNewListAnalytics = (productInfo, createNewListTitle)=>{
    const pageType = getPageType();
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(pageType, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .PRODUCT_DETAILS */ .OH, ":").concat(createNewListTitle === null || createNewListTitle === void 0 ? void 0 : createNewListTitle.toLowerCase(), ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .CLOSE */ .F$),
        eventMsg: "n/a",
        eventName: "".concat(pageType, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .PRODUCT_DETAILS */ .OH, ":").concat(createNewListTitle === null || createNewListTitle === void 0 ? void 0 : createNewListTitle.toLowerCase(), ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .CLOSE */ .F$),
        eventStatus: "n/a",
        eventType: "".concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .WISHLIST_SAVE */ .O1),
        internalLinkName: "".concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .CLOSE */ .F$),
        internalLinkPosition: "".concat(pageType),
        internalLinkType: "".concat(pageType, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .SAVE_TO_LIST */ .IP),
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(pageType, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .PRODUCT_DETAILS */ .OH, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .SAVE_TO_LIST */ .IP)
    };
    pushToAdobeDataLayer(eventInfo, productInfo);
};
const closeCreateNewListSuccessAnalytics = function(productInfo) {
    let createListData = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", createNewListTitle = arguments.length > 2 ? arguments[2] : void 0, successTitle = arguments.length > 3 ? arguments[3] : void 0;
    const pageType = getPageType();
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(pageType, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .PRODUCT_DETAILS */ .OH, ":").concat(createNewListTitle === null || createNewListTitle === void 0 ? void 0 : createNewListTitle.toLowerCase(), ":").concat(successTitle === null || successTitle === void 0 ? void 0 : successTitle.toLowerCase(), ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .CLOSE */ .F$),
        eventMsg: "n/a",
        eventName: "".concat(pageType, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .PRODUCT_DETAILS */ .OH, ":").concat(createNewListTitle === null || createNewListTitle === void 0 ? void 0 : createNewListTitle.toLowerCase(), ":").concat(successTitle === null || successTitle === void 0 ? void 0 : successTitle.toLowerCase(), ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .CLOSE */ .F$),
        eventStatus: "n/a",
        eventType: "".concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .WISHLIST_SAVE */ .O1),
        internalLinkName: "".concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .CLOSE */ .F$),
        internalLinkPosition: "".concat(pageType),
        internalLinkType: "".concat(pageType, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .SAVE_TO_LIST */ .IP, ":").concat(createListData),
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(pageType, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .PRODUCT_DETAILS */ .OH, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .SAVE_TO_LIST */ .IP)
    };
    pushToAdobeDataLayer(eventInfo, productInfo);
};
const closeSelectMyListAnalytics = function(productInfo) {
    let selectedData = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", successTitle = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    const pageType = getPageType();
    const eventPath = "".concat(pageType, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .PRODUCT_DETAILS */ .OH, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .SELECT_MY_LIST */ .oF);
    const eventData = successTitle ? "".concat(eventPath, ":").concat(successTitle, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .CLOSE */ .F$) : "".concat(eventPath, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .CLOSE */ .F$);
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: eventData,
        eventMsg: "n/a",
        eventName: eventData,
        eventStatus: "n/a",
        eventType: "".concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .WISHLIST_SAVE */ .O1),
        internalLinkName: "".concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .CLOSE */ .F$),
        internalLinkPosition: "".concat(pageType),
        internalLinkType: "".concat(pageType, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .SAVE_TO_LIST */ .IP, ":").concat(selectedData),
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(pageType, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .PRODUCT_DETAILS */ .OH, ":").concat(_components_SaveToList_constant__WEBPACK_IMPORTED_MODULE_0__/* .SAVE_TO_LIST */ .IP)
    };
    pushToAdobeDataLayer(eventInfo, productInfo);
};


/***/ }),

/***/ 4943:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F$": function() { return /* binding */ CLOSE; },
/* harmony export */   "IP": function() { return /* binding */ SAVE_TO_LIST; },
/* harmony export */   "Ik": function() { return /* binding */ WISHLIST_DELETE; },
/* harmony export */   "O1": function() { return /* binding */ WISHLIST_SAVE; },
/* harmony export */   "OH": function() { return /* binding */ PRODUCT_DETAILS; },
/* harmony export */   "V7": function() { return /* binding */ SAVE_TO_LIST_GUEST; },
/* harmony export */   "oF": function() { return /* binding */ SELECT_MY_LIST; }
/* harmony export */ });
const PRODUCT_DETAILS = "product details";
const WISHLIST_SAVE = "wishlist save";
const WISHLIST_DELETE = "wishlist delete";
const SELECT_MY_LIST = "select my list";
const CLOSE = "close";
const SAVE_TO_LIST = "save to list";
const SAVE_TO_LIST_GUEST = "save to list guest";


/***/ }),

/***/ 4165:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24400);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9473);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _components_SaveToList_localization__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(34428);
/* harmony import */ var _components_Shared_Image__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70914);
/* harmony import */ var _constants_regex__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(49139);
/* harmony import */ var _store_features_favoritesSlice__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7737);
/* harmony import */ var _store_features_genericSlice__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(88751);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(55760);
/* harmony import */ var _constants_routes__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(64757);
/* harmony import */ var _public_icons_modal_close_svg__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(55619);
/* harmony import */ var _components_SaveToList_index_module_scss__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(89986);
/* harmony import */ var _components_SaveToList_index_module_scss__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_components_SaveToList_index_module_scss__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _components_SaveToList_analytics__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(65258);
















const ListForm = next_dynamic__WEBPACK_IMPORTED_MODULE_5___default()(()=>__webpack_require__.e(/* import() */ 3073).then(__webpack_require__.bind(__webpack_require__, 43073)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(43073)
            ]
    }
});
const CreateForm = next_dynamic__WEBPACK_IMPORTED_MODULE_5___default()(()=>__webpack_require__.e(/* import() */ 3042).then(__webpack_require__.bind(__webpack_require__, 43042)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(43042)
            ]
    }
});
const SaveToList = (props)=>{
    const { t  } = (0,next_i18next__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)("common");
    const staticText = (0,_components_SaveToList_localization__WEBPACK_IMPORTED_MODULE_12__/* .getTranslations */ .F)(t);
    const { globalConfig: { internationalization: { locale: newLocale = "" , language =""  } = {}  } = {}  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(_store_features_genericSlice__WEBPACK_IMPORTED_MODULE_8__/* .selectGenericState */ .Px);
    const { productSku ="" , showListSaveAndCreate =false , createList =false , listSaveAndCreateClose =()=>{} , handleSuccessCallBack =()=>{} , listData ={} , editListText ="" , selectedListDetails ={} , getProductInfo ={} , moveToList =false , moveOrDeleteFromListName ="" , currentList ={} , productData =[] , selectedItems =[] , productQtyObj ={} , productInfoPdp ={}  } = props || {};
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useDispatch */ .I0)();
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    const [saveBtnStatus, setSaveBtnStatus] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true);
    const [createNewList, setCreateNewList] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(createList);
    const [headerText, setHeaderText] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [decText, setDecText] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [userLists, setUserLists] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const [listNameValidationList, setListNameValidationList] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const [nameValidationErrorMsg, setNameValidationErrorMsg] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [showNameValidationError, setShowNameValidationError] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [newListName, setNewListName] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [projectName, setProjectName] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [dec, setDec] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [selectedList, setSelectedList] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [createListData, setCreateListData] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({});
    const [selectedListData, setSelectedListData] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({});
    const [createListAddItemsSuccess, setCreateListAddItemsSuccess] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [count, setCount] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0);
    const [listNamesLoader, setListNamesLoader] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true);
    const productInfoPlp = getProductInfo !== null && getProductInfo !== void 0 ? getProductInfo : "{}";
    const productInfo = Object.keys(productInfoPlp).length !== 0 ? productInfoPlp : productInfoPdp;
    const [moveToListResponse, setMoveToListResponse] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({});
    const getUserCreatedListData = ()=>{
        dispatch((0,_store_features_favoritesSlice__WEBPACK_IMPORTED_MODULE_7__/* .getMyAccountLists */ .jP)()).unwrap().then((response)=>{
            const locale = newLocale === "fr-CA" ? "en-CA" : newLocale;
            const data = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_9__/* .getUserCreatedLists */ .$1Y)(response, locale, moveOrDeleteFromListName);
            setUserLists(data === null || data === void 0 ? void 0 : data.lists);
            moveOrDeleteFromListName ? setListNameValidationList([
                ...(data === null || data === void 0 ? void 0 : data.listNames) || [],
                moveOrDeleteFromListName
            ]) : setListNameValidationList(data === null || data === void 0 ? void 0 : data.listNames);
            setListNamesLoader(false);
        }).catch((error)=>{});
    };
    const listNameValidation = (e)=>{
        var ref;
        let value = e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : ref.value;
        value = (value === null || value === void 0 ? void 0 : value.length) < 37 ? value : value.slice(0, 36);
        setNewListName(value);
        setNameValidationErrorMsg(staticText.createNameError);
        if ((value === null || value === void 0 ? void 0 : value.trim().length) < 3 || (value === null || value === void 0 ? void 0 : value.trim().length) > 36 || !_constants_regex__WEBPACK_IMPORTED_MODULE_13__/* .SAVE_TO_LIST_NAME_FIELD_REGEX.test */ .cH.test(value)) {
            setNameValidationErrorMsg(staticText.createNameError);
            setShowNameValidationError(true);
        } else if ((0,_utils_helper__WEBPACK_IMPORTED_MODULE_9__/* .getIsNameDuplicate */ .Cxt)(value.trim(), listNameValidationList)) {
            setNameValidationErrorMsg(staticText.createSameNameError);
            setShowNameValidationError(true);
        } else if ((0,_utils_helper__WEBPACK_IMPORTED_MODULE_9__/* .getIsSystemDefinedName */ .Qss)(value.trim())) {
            setNameValidationErrorMsg(staticText.createSystemNameError);
            setShowNameValidationError(true);
        } else {
            setShowNameValidationError(false);
        }
    };
    const projectNameValidation = (e)=>{
        var ref;
        const value = e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : ref.value;
        (value === null || value === void 0 ? void 0 : value.length) < 37 ? setProjectName(value) : setProjectName(value.slice(0, 36));
    };
    const handleSelectedList = (list)=>{
        setSelectedList(list === null || list === void 0 ? void 0 : list.id);
        setSelectedListData(list);
    };
    const closeModalHandle = ()=>{
        if (saveBtnStatus && !createNewList) {
            (0,_components_SaveToList_analytics__WEBPACK_IMPORTED_MODULE_14__/* .closeSaveToListAnalytics */ .$b)(productInfo);
        }
        if (!saveBtnStatus && !createNewList) {
            const selectedData = selectedListData === null || selectedListData === void 0 ? void 0 : selectedListData.name;
            const successTitle = createListAddItemsSuccess ? staticText === null || staticText === void 0 ? void 0 : staticText.saveToListActionTitle : null;
            (0,_components_SaveToList_analytics__WEBPACK_IMPORTED_MODULE_14__/* .closeSelectMyListAnalytics */ .jX)(productInfo, selectedData, successTitle);
        }
        if (saveBtnStatus && createNewList) {
            const createNewListTitle = staticText === null || staticText === void 0 ? void 0 : staticText.saveToListCreateNewBtn;
            (0,_components_SaveToList_analytics__WEBPACK_IMPORTED_MODULE_14__/* .closeCreateNewListAnalytics */ .iB)(productInfo, createNewListTitle);
        }
        if (createListAddItemsSuccess && !saveBtnStatus && createNewList) {
            const createListData = newListName;
            const createNewListTitle1 = staticText === null || staticText === void 0 ? void 0 : staticText.saveToListCreateNewBtn;
            const successTitle1 = staticText === null || staticText === void 0 ? void 0 : staticText.saveToListActionTitle;
            (0,_components_SaveToList_analytics__WEBPACK_IMPORTED_MODULE_14__/* .closeCreateNewListSuccessAnalytics */ .NG)(productInfo, createListData, createNewListTitle1, successTitle1);
        }
        if (moveToList && createListAddItemsSuccess) handleSuccessCallBack(moveToListResponse);
        listSaveAndCreateClose();
    };
    const handleCreateNewList = ()=>{
        const createNewListTitle = staticText === null || staticText === void 0 ? void 0 : staticText.saveToListCreateNewBtn;
        (0,_components_SaveToList_analytics__WEBPACK_IMPORTED_MODULE_14__/* .dataLayerCreateNewListButton */ .p5)(productInfo, createNewListTitle);
        setSelectedList("");
        setCreateNewList(true);
        setSaveBtnStatus(true);
    };
    const handleDec = (e)=>{
        const { value  } = e.target;
        setCount(value === null || value === void 0 ? void 0 : value.length);
        setDec(value);
    };
    const handleMoveItemsFromList = async (list, listInfo)=>{
        dispatch((0,_store_features_favoritesSlice__WEBPACK_IMPORTED_MODULE_7__/* .moveItemsFromList */ .s$)({
            list: list,
            listData: listInfo,
            currentList,
            productData,
            selectedItems,
            productQtyObj
        })).unwrap().then((response)=>{
            var ref, ref1, ref2;
            const locale = newLocale === "fr-CA" ? "en-CA" : newLocale;
            setCreateListData({
                name: response === null || response === void 0 ? void 0 : (ref = response.addResponse) === null || ref === void 0 ? void 0 : ref.name[locale],
                version: response === null || response === void 0 ? void 0 : (ref1 = response.addResponse) === null || ref1 === void 0 ? void 0 : ref1.version,
                id: response === null || response === void 0 ? void 0 : (ref2 = response.addResponse) === null || ref2 === void 0 ? void 0 : ref2.id
            });
            setHeaderText(staticText === null || staticText === void 0 ? void 0 : staticText.saveToListActionTitle);
            setDecText(staticText === null || staticText === void 0 ? void 0 : staticText.moveToListSuccessDec);
            setCreateListAddItemsSuccess(true);
            setSaveBtnStatus(false);
            setMoveToListResponse(response);
        }).catch((error)=>{});
    };
    const handleCreateListAndAddProductsToIt = async ()=>{
        if (createListAddItemsSuccess) {
            if (moveToList) handleSuccessCallBack(moveToListResponse);
            listSaveAndCreateClose();
            return;
        }
        setSaveBtnStatus(true);
        const listInfo = {};
        const list = {};
        if (createNewList && !editListText) {
            const createListData = newListName;
            const successDesc = staticText === null || staticText === void 0 ? void 0 : staticText.saveEventMsgCreateList;
            const createNewListTitle = staticText === null || staticText === void 0 ? void 0 : staticText.saveToListCreateNewBtn;
            const successTitle = staticText === null || staticText === void 0 ? void 0 : staticText.saveToListActionTitle;
            listInfo["name"] = newListName === null || newListName === void 0 ? void 0 : newListName.trim();
            listInfo["project"] = projectName;
            listInfo["description"] = dec;
            (0,_components_SaveToList_analytics__WEBPACK_IMPORTED_MODULE_14__/* .dataLayerCreateNewSaveListButton */ .Yt)(productInfo, createListData, successDesc, createNewListTitle, successTitle);
        } else {
            var ref, ref1;
            const selectedData = selectedListData.name;
            const successDesc1 = staticText === null || staticText === void 0 ? void 0 : staticText.saveEventMsgMyList;
            const successTitle1 = staticText === null || staticText === void 0 ? void 0 : staticText.saveToListActionTitle;
            var ref2;
            list["id"] = (ref2 = selectedListData === null || selectedListData === void 0 ? void 0 : selectedListData.id) !== null && ref2 !== void 0 ? ref2 : (ref = selectedListDetails[0]) === null || ref === void 0 ? void 0 : ref.id;
            var ref3;
            list["version"] = (ref3 = selectedListData === null || selectedListData === void 0 ? void 0 : selectedListData.version) !== null && ref3 !== void 0 ? ref3 : (ref1 = selectedListDetails[0]) === null || ref1 === void 0 ? void 0 : ref1.version;
            listInfo["name"] = newListName === null || newListName === void 0 ? void 0 : newListName.trim();
            listInfo["project"] = projectName;
            listInfo["description"] = dec;
            (0,_components_SaveToList_analytics__WEBPACK_IMPORTED_MODULE_14__/* .dataLayerMyListSaveListButton */ .Y$)(productInfo, selectedData, successDesc1, successTitle1);
        }
        if (moveToList) {
            handleMoveItemsFromList(list, listInfo);
            return;
        }
        editListText ? dispatch((0,_store_features_favoritesSlice__WEBPACK_IMPORTED_MODULE_7__/* .editList */ .Du)({
            list: list,
            listData: listInfo
        })).unwrap().then(async (response)=>{
            setSaveBtnStatus(false);
            handleSuccessCallBack(response);
            dispatch((0,_store_features_favoritesSlice__WEBPACK_IMPORTED_MODULE_7__/* .getMyAccountListsWithLineItems */ .WQ)());
        }).catch((errror)=>{}) : dispatch((0,_store_features_favoritesSlice__WEBPACK_IMPORTED_MODULE_7__/* .addProductToList */ .XV)({
            sku: productSku,
            list: list,
            listData: listInfo,
            createList
        })).unwrap().then(async (response)=>{
            const locale = newLocale === "fr-CA" ? "en-CA" : newLocale;
            setCreateListData({
                name: response === null || response === void 0 ? void 0 : response.name[locale],
                version: response === null || response === void 0 ? void 0 : response.version,
                id: response === null || response === void 0 ? void 0 : response.id
            });
            setHeaderText(staticText === null || staticText === void 0 ? void 0 : staticText.saveToListActionTitle);
            setDecText(staticText === null || staticText === void 0 ? void 0 : staticText.saveToListActionDec);
            setCreateListAddItemsSuccess(true);
            setSaveBtnStatus(false);
            handleSuccessCallBack();
            createList ? handleSuccessCallBack(response) : handleSuccessCallBack();
        }).catch((errror)=>{});
    };
    const handleListNameClick = ()=>{
        router.replace({
            pathname: "/".concat(language).concat(_constants_routes__WEBPACK_IMPORTED_MODULE_10__/* .MY_LISTS_PAGE_PATH */ .PN),
            query: {
                listId: createListData === null || createListData === void 0 ? void 0 : createListData.id
            }
        }).then(()=>{
            router.reload();
        });
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        getUserCreatedListData();
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (moveToList) {
            setHeaderText(staticText === null || staticText === void 0 ? void 0 : staticText.moveToList);
            setDecText(staticText === null || staticText === void 0 ? void 0 : staticText.moveToList);
        }
    }, [
        moveToList
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        var ref;
        if (((ref = Object.keys(listData)) === null || ref === void 0 ? void 0 : ref.length) > 0) {
            setProjectName(listData === null || listData === void 0 ? void 0 : listData.project);
            setNewListName(listData === null || listData === void 0 ? void 0 : listData.name);
            setDec(listData === null || listData === void 0 ? void 0 : listData.description);
            setHeaderText(editListText);
            setDecText(staticText === null || staticText === void 0 ? void 0 : staticText.saveToListCreateDec);
            handleSelectedList(selectedList);
        }
    }, [
        listData
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        document.body.style.overflow = showListSaveAndCreate ? "hidden" : "auto";
        return ()=>{
            document.body.style.overflow = "auto";
        };
    }, [
        showListSaveAndCreate
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (createNewList && !showNameValidationError || !createNewList && selectedList) {
            setSaveBtnStatus(false);
        } else {
            setSaveBtnStatus(true);
        }
    }, [
        newListName,
        selectedList
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (!editListText) {
            if (createNewList) {
                setHeaderText(staticText === null || staticText === void 0 ? void 0 : staticText.saveToListCreateHeader);
                setDecText(staticText === null || staticText === void 0 ? void 0 : staticText.saveToListCreateDec);
            } else if (moveToList) {
                setHeaderText(staticText === null || staticText === void 0 ? void 0 : staticText.moveToList);
                setDecText(staticText === null || staticText === void 0 ? void 0 : staticText.moveToListDec);
            } else {
                setHeaderText(staticText === null || staticText === void 0 ? void 0 : staticText.saveToListSaveHeader);
                setDecText(staticText === null || staticText === void 0 ? void 0 : staticText.saveToListSaveDec);
            }
        }
        setSaveBtnStatus(true);
    }, [
        createNewList
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        let timerConst;
        if (createListAddItemsSuccess) {
            timerConst = setTimeout(()=>{
                if (moveToList) handleSuccessCallBack(moveToListResponse);
                listSaveAndCreateClose();
                setCreateListAddItemsSuccess(false);
                setNameValidationErrorMsg("");
                setNewListName("");
                setProjectName("");
                setDec("");
                setMoveToListResponse({});
            }, 3000);
        }
        return ()=>{
            clearTimeout(timerConst);
        };
    }, [
        createListAddItemsSuccess
    ]);
    if (listNamesLoader && showListSaveAndCreate) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_components_SaveToList_index_module_scss__WEBPACK_IMPORTED_MODULE_15___default().SaveToListWrapper),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "save-to-list-modal",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "loading-container",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "loading-text",
                        children: staticText === null || staticText === void 0 ? void 0 : staticText.saveToListLoading
                    })
                })
            })
        });
    }
    return showListSaveAndCreate ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_components_SaveToList_index_module_scss__WEBPACK_IMPORTED_MODULE_15___default().SaveToListWrapper),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "save-to-list-modal",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "modal-body",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "back-close-btn",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "close-btn",
                                onClick: closeModalHandle,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Shared_Image__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                    src: _public_icons_modal_close_svg__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z === null || _public_icons_modal_close_svg__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z === void 0 ? void 0 : _public_icons_modal_close_svg__WEBPACK_IMPORTED_MODULE_11__/* ["default"].src */ .Z.src,
                                    role: "presentation",
                                    alt: "close",
                                    width: "30",
                                    height: "30"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "modal-content",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "list-header",
                                    children: headerText
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "list-dec",
                                    children: decText
                                }),
                                !createNewList && !createListAddItemsSuccess ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "create-new-list",
                                    onClick: handleCreateNewList,
                                    children: staticText === null || staticText === void 0 ? void 0 : staticText.saveToListCreateNewBtn
                                }) : null,
                                createListAddItemsSuccess && !createList ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "create-new-list",
                                    onClick: handleListNameClick,
                                    children: createListData === null || createListData === void 0 ? void 0 : createListData.name
                                }) : null,
                                !createListAddItemsSuccess && createNewList ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CreateForm, {
                                    listNameValidation: listNameValidation,
                                    newListName: newListName,
                                    showNameValidationError: showNameValidationError,
                                    nameValidationErrorMsg: nameValidationErrorMsg,
                                    projectNameValidation: projectNameValidation,
                                    projectName: projectName,
                                    dec: dec,
                                    handleDec: handleDec,
                                    count: count
                                }) : null,
                                !createListAddItemsSuccess && !createNewList ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ListForm, {
                                    createNewList: createNewList,
                                    createListAddItemsSuccess: createListAddItemsSuccess,
                                    userLists: userLists,
                                    handleSelectedList: handleSelectedList,
                                    selectedList: selectedList
                                }) : null
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "action-btn",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        className: "action-btn-item",
                        disabled: saveBtnStatus,
                        onClick: handleCreateListAndAddProductsToIt,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "action-btn-item-txt",
                            children: createListAddItemsSuccess ? createList ? staticText === null || staticText === void 0 ? void 0 : staticText.saveToListNewActionSave : staticText === null || staticText === void 0 ? void 0 : staticText.saveToListActionSaved : staticText === null || staticText === void 0 ? void 0 : staticText.saveToListActionSave
                        })
                    })
                })
            ]
        })
    }) : null;
};
/* harmony default export */ __webpack_exports__["Z"] = (SaveToList);


/***/ }),

/***/ 34428:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ getTranslations; }
/* harmony export */ });
const getTranslations = (t)=>{
    return {
        createNameError: t("kf.saveToList.create.name.error"),
        createSameNameError: t("kf.saveToList.create.same.name.error"),
        createSystemNameError: t("kf.saveToList.create.system.name.error"),
        saveToListActionTitle: t("kf.saveToList.action.success.title"),
        saveToListActionDec: t("kf.saveToList.action.success.dec"),
        saveToListCreateHeader: t("kf.saveToList.create.header"),
        saveToListCreateDec: t("kf.saveToList.create.dec"),
        saveToListSaveHeader: t("kf.saveToList.save.header"),
        saveToListSaveDec: t("kf.saveToList.save.dec"),
        saveToListLoading: t("kf.saveToList.loading"),
        saveToListCreateNewBtn: t("kf.saveToList.create.new.btn.txt"),
        saveToListActionSaved: t("kf.saveToList.action.saved"),
        saveToListActionSave: t("kf.saveToList.action.save"),
        saveToListNewActionSave: t("kf.saveToList.action.new.saved"),
        createLabel: t("kf.saveToList.create.name.label"),
        projectLabel: t("kf.saveToList.create.project.label"),
        dec: t("kf.saveToList.create.dec.label"),
        title: t("kf.saveToList.myList.titile"),
        saveEventMsgCreateList: t("kf.save.eventMsg.create.list"),
        saveEventMsgMyList: t("kf.save.eventMsg.myList"),
        moveToList: t("kf.moveToList.header"),
        moveToListDec: t("kf.moveToList.dec"),
        moveToListSuccessDec: t("kf.moveToList.success.dec")
    };
};


/***/ }),

/***/ 47486:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ListConfirmationModalWrapper":"ListConfirmationModal_ListConfirmationModalWrapper___xKQ_"};

/***/ }),

/***/ 89986:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"SaveToListWrapper":"SaveToList_SaveToListWrapper__GFfMQ"};

/***/ })

}]);